import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const StyledHeader = styled('header')(
  ({ theme }) => `
      z-index: 2;
      position: relative;
      width: 100%;
      margin-top: ${theme.DS_spacing(['xs'])};
      margin-bottom: ${theme.DS_spacing(['md'])};
      > div > div {
       > .MuiGrid-container{
         align-items: center;
         > .MuiGrid-root{
          padding-left: ${theme.DS_spacing(['sm'])};
         }
           > .MuiGrid-root:last-of-type {
            display: flex;
            align-self: flex-end;
            justify-content: flex-end;
            margin-right: -${theme.DS_spacing(['md'])};
            padding-top: 18px;
          }
            > .MuiGrid-item{
          padding-top:2px;
         }
        }
      }

      
      h2 {
        margin-top: ${theme.DS_spacing(['xs'])};
      }
            
   ${theme.breakpoints.up('lg')} {
      margin-bottom: ${theme.DS_spacing(['xxl'])};
   
      h2{
        max-width: 16ch;
      }
    }
  }
  ${theme.breakpoints.up('md')} {
    > div > div {
       > .MuiGrid-container{
         > .MuiGrid-root:last-of-type {
          padding-top: 24px;
         }
       } 
     }    
  }
`,
);

const descriptionMargins = ({ theme }) => `
    margin-top: 16px;
    
    ${theme.breakpoints.up('md')} {
      margin-top: 24px;
    }
    ${theme.breakpoints.up('lg')} {
      max-width: 50ch;
    }

`;

export const StyledDescription = styled(Typography)`
  ${descriptionMargins};
`;

export const StyledRichDescription = styled(Typography)(
  ({ theme }) => ` 
  ${descriptionMargins({ theme })};
     ${theme.breakpoints.up('lg')} {
   
        max-width: 100%;
      
     }
`,
);

export const StyledButtonWrapper = styled('div')(
  ({ theme }) => ` 
    margin-top: -${theme.DS_spacing(['lg'])};
    max-height: ${theme.DS_spacing(['xxl'])};
   
    ${theme.breakpoints.up('md')} {
       margin-top: -${theme.DS_spacing(['xl'])};
       margin-bottom: 0.5rem;
    }
   
    ${theme.breakpoints.up('lg')} {
      margin-top: 0;
      margin-bottom: 0;
      > a {
        span {
          > div {
            margin-right: ${theme.DS_spacing(['xxxs'])};
          }
        }
      }
    }
    
     > a {
      padding: 12px 0 12px 0;
      justify-content: flex-end;
   
      span {
      text-transform: flex-end;
      align-items: flex-end;
      flex-shrink: 0;
      > span {
         max-width: 32ch;
      }

       > div {
          margin-right: 0;
          margin-bottom: 0;
        }
      }
   }
  
  `,
);
